export class ContentSharingTweetModel {
    body: string = '';
    url: string = '';

    constructor(
        body: string,
        url: string
    ) {
        this.body = body;
        this.url = url;
    }
}
